import { MemberHashKey } from '@common/consts/memberHashKey'
import { hasGivenConsent } from '@common/utils/cookies/hasGivenConsent'
import type { Member } from '@vista-digital/ocapi-types/v1'

export const updateStoredMemberHash = (member: Member) => {
    if (!member?.hash) return
    if (!hasGivenConsent()) return
    localStorage.setItem(MemberHashKey, member.hash)
}
